<template>
	<div class="grid addbeach">
		<div class="grid">
			<el-form key="form" ref="beachform" :rules="rules" :model="newbeach" status-icon @keyup.enter.native="addBeach('beachform')">
				<el-form-item label="Nome spiaggia" key="name" prop="name">
						<el-input type="text" v-model="newbeach.name" name="name" ref="name"></el-input>
				</el-form-item>
			</el-form>
			<div class="grid btnlist" key="btnlist">
				<button class="btn" @click="$emit('close')" v-if="$store.state.hotels.hotels.length > 0"><unicon name="times" height="16" width="16" fill="#333"  /></button>
				<button class="btn green block" @click="addBeach('beachform')">Aggiungi spiaggia</button>
			</div>
			<div class="grid help">
				<small><a href="https://blog.ombrelleria.com/crea-la-tua-prima-spiaggia/" target="new">Ti serve <span class="text green">aiuto?</span></a></small>
			</div>
		</div>
	</div>
</template>

<script>
// import _ from 'lodash'
// import moment from 'moment'
// import helper from '../Mixins/helper'
export default {
	name: 'Addbeach',
	// mixins: [helper],
	props: {
		// hotel: Object
	},
	data () {
		return {
			changes: false,
			newbeach: {
				name: ''
			},
			rules: {
					name: [
							{ required: true, message: 'prego inserire un nome', trigger: 'blur' }
				]
			}
		}
	},
	methods: {
		addBeach (formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log('good to go')
					this.$store.dispatch('hotels/addBeach', this.newbeach).then(() => {
						this.$store.dispatch('ombrelloni/getOmbrelloni').then(() => {
							this.$emit('open', 'editgrid')
							this.$emit('close')
						})
					})
				} else {
					console.log('error submit')
				}
			})
		},
		show (section) {
			console.log(section)
			this.$emit('open', section)
		},
		save () {
			console.log('save')
			// this.$store.dispatch('hotels/updateHotel', this.hotel)
		}
	},
	filters: {
	},
	watch: {
	},
	computed: {
	},
	beforeMount () {
	},
	mounted () {
		// console.log('created', this.$refs['name'])
		console.log(this.$refs.name.focus())
		// this.$refs['name'].focus()
	},
	beforeDestroy () {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
